import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import localeIt from '@angular/common/locales/it';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { AppConfig } from './app-config.loader';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuditModule } from './features/audit/audit.module';
import { ClassificheInScadenzaModule } from './features/classifiche-in-scadenza/classifiche-in-scadenza.module';
import { ElenchiModule } from './features/elenchi/elenchi.module';
import { ErrorlogsModule } from './features/errorlogs/errologs.module';
import { EvidenzeModule } from './features/evidenze/evidenze.module';
import { GestioneClassQualModule } from './features/gestione-class-qual/gestione-clsss-qual.module';
import { GestioneIndirizziModule } from './features/gestione-indirizzi/gestione-indirizzi.module';
import { GestionePosizioniModule } from './features/gestione-posizioni/gestione-posizioni.module';
import { ProdottiSoftwareModule } from './features/prodotti-software/prodotti-software.module';
import { GestioneUtentiModule } from './features/gestione-utenti/gestione-utenti.module';
import { NuovoModule } from './features/nuovo/nuovo.module';
import { RegistriModule } from './features/registri/registri.module';
import { RicercaModule } from './features/ricerca/ricerca.module';
import { StatisticheModule } from './features/statistiche/statistiche.module';
import { VisualizzaModule } from './features/visualizza/visualizza.module';
import { LayoutModule } from './layout/layout.module';
import { OperazioniMassiveModule } from './features/operazioni-massive/operazioni-massive.module';
import { PassaggioConsegneModule } from './features/passaggio-consegne/passaggio-consegne.module';
import { TopbarSearchComponent } from "./shared/components/topbar-search.component";
import { ProfileMenuShowPermissionComponent } from "./shared/components/profile-menu/show-permission.component";
import { PromemoriaModule } from './features/promemoria/promemoria.module';

registerLocaleData(localeIt, 'it');

@NgModule({
  declarations: [
    AppComponent
  ],
  bootstrap: [AppComponent],
  imports: [BrowserModule,
    BrowserAnimationsModule,
    ConfirmDialogModule,
    ToastModule,
    AppRoutingModule,
    LayoutModule,
    EvidenzeModule,
    VisualizzaModule,
    GestionePosizioniModule,
    NuovoModule,
    RicercaModule,
    GestioneIndirizziModule,
    ElenchiModule,
    ProdottiSoftwareModule,
    GestioneClassQualModule,
    GestioneUtentiModule,
    StatisticheModule,
    AuditModule,
    RegistriModule,
    ClassificheInScadenzaModule,
    ErrorlogsModule,
    OperazioniMassiveModule,
    PassaggioConsegneModule,
    PromemoriaModule,
    TopbarSearchComponent,ProfileMenuShowPermissionComponent],
  providers: [
    MessageService,
    ConfirmationService,
    {
      provide: APP_INITIALIZER,
      useFactory: (config: AppConfig) => () => config.load(),
      deps: [AppConfig],
      multi: true
    },
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class AppModule { }
